import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=4958d168&scoped=true"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=4958d168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958d168",
  null
  
)

export default component.exports